import React from 'react';

const Preinscription = (props) => {
  const { categories, name, surname, email, country, phone, handleRadio, errors } = props;

  return (
    <div className="row">
      <div className="col-12 py-3">
        <form>
          <div className="row form-group">
            <label htmlFor="name" className="col-4 col-form-label text-right"><span className="red">*</span> Primer nombre</label>
            <div className="col-6">
              <input type="text" className={`form-control ${errors?.name ? 'is-invalid' : ''}`} name="name" {...name} />
              <span className="help-block red">{errors?.name ? 'Requerido' : ''}</span>
            </div>
          </div>

          <div className="row form-group">
            <label htmlFor="surname" className="col-4 col-form-label text-right"><span className="red">*</span> Apellido</label>
            <div className="col-6">
              <input type="text" className={`form-control ${errors?.surname ? 'is-invalid' : ''}`} name="surname" {...surname} />
              <span className="help-block red">{errors?.surname ? 'Requerido' : ''}</span>
            </div>
          </div>
          
          <div className="row form-group">
            <label htmlFor="email" className="col-4 col-form-label text-right"><span className="red">*</span> Correo electrónico</label>
            <div className="col-6">
              <input type="email" className={`form-control ${errors?.email ? 'is-invalid' : ''}`} name="email" {...email} />
              <span className="help-block red">{errors?.email ? 'Requerido' : ''}</span>
            </div>
          </div>
          
          <div className="row form-group">
            <label htmlFor="country" className="col-4 col-form-label text-right"><span className="red">*</span> País</label>
            <div className="col-6">
              <input type="text" className={`form-control ${errors?.country ? 'is-invalid' : ''}`} name="country" {...country} />
              <span className="help-block red">{errors?.country ? 'Requerido' : ''}</span>
            </div>
          </div>
          
          <div className="row form-group">
            <label htmlFor="phone" className="col-4 col-form-label text-right"><span className="red">*</span> Teléfono</label>
            <div className="col-6">
              <input type="text" className={`form-control ${errors?.phone ? 'is-invalid' : ''}`} name="phone" {...phone} />
              <span className="help-block red">{errors?.phone ? 'Requerido' : ''}</span>
            </div>
          </div>
          
          <div className="row form-group">
            <label htmlFor="category" className="col-4 col-form-label text-right"><span className="red">*</span> Categoría</label>
            <div className="col-6">
              {categories.map((item, index) => (
                <div kye={`index-${index}`} className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="category"
                    id={`n-${item.id}`}
                    value={item.nombre}
                    onChange={(event) => handleRadio(event, item.price)}
                  />
                  <label className="form-check-label" htmlFor={`n-${item.id}`}>
                    <span data-toggle="tooltip" data-placement="right" title={item.ayuda}>
                      {item.nombre}
                    </span>
                  </label>
                </div>
              ))}
              <span className="help-block red">{errors?.category ? 'Requerido' : ''}</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Preinscription;
